export const TABLE_LOADER_CONSTANT_SIZES = {
    LOADER_CONTENT_SIZE: '80px',
    LOADER_MIN_HEIGHT: '400px'
} as const;
